/**
 * Lake Charles Vendors Page
 *
 * Simple wrapper that imports the parameterized VendorsPage from city-landing-core
 * and passes Lake Charles-specific configuration.
 */

import React from 'react';
import { SEOHead } from '@/components/shared/seo/SEOHead';
import { VendorsPage, VendorWaitlistForm, VendorFAQSection } from '@core';
import { submitVendorWaitlist } from '../services/vendorWaitlistService';
import lakeCharlesConfig from '../city.config';

export function LakeCharlesVendorsPage() {
  return (
    <>
      <SEOHead
        title="Vendors"
        description="Join the ToolboxLogic vendor network in Lake Charles. Connect with residents, offer services, and grow your business."
        canonical="https://lakecharles.toolboxlogic.com/vendors"
        keywords="Lake Charles vendors, local services, community marketplace, Louisiana"
      />
      <VendorsPage
        cityName={lakeCharlesConfig.identity.cityName}
        stateName={lakeCharlesConfig.identity.stateName}
        annualSpending={(lakeCharlesConfig as any).economics.annualConsumerSpending}
        processingRate="~2.5% - 2.9%"
        vendorMonthlyFee="$25"
        vendorAnnualFee="$180"
        heroImage="/media_shared/vendor-hero.png"
        communityGridImage="/media_shared/community-grid.png"
        VendorWaitlistFormComponent={
          <VendorWaitlistForm
            cityName={lakeCharlesConfig.identity.cityName}
            stateName={lakeCharlesConfig.identity.stateName}
            vendorMonthlyFee="$25"
            vendorAnnualFee="$180"
            contactEmail="" /* "vendors@toolboxlogic.com" */
            onSubmit={async (data) => {
              const res = await submitVendorWaitlist(data);
              return { success: res.success, error: res.error };
            }}
          />
        }
        VendorFAQComponent={<VendorFAQSection />}
      />
    </>
  );
}
